/**
 * Cart Page GWP Bridge — connects Pipeline's /cart AJAX to the GWP engine
 *
 * Pipeline's theme.js already handles AJAX qty changes and section refresh
 * on the /cart page. This script:
 * 1. Observes Pipeline's section refreshes and dispatches theme:cart:change
 *    so the GWP engine can auto-add/remove gifts
 * 2. After a delay (to let GWP engine finish), does a follow-up section
 *    refresh so the GWP item appears/disappears in the line items
 */
(function () {
  'use strict';

  if (!document.querySelector('[data-section-type="cart"]')) return;

  var SELECTORS = {
    lineItems: '[data-line-items]',
    cartEmpty: '[data-cart-empty]',
    cartForm: '[data-cart-form]',
    cartBottom: '[data-cart-bottom]',
    cartSubtotal: '[data-cart-subtotal]',
    cartFinal: '[data-cart-final]',
    cartMessage: '[data-cart-message]',
    gwpMessages: '[data-gwp-messages]',
    headerCartCount: '[data-header-cart-count]',
    headerCartPrice: '[data-header-cart-price]',
    headerCartFull: '[data-header-cart-full]',
  };

  var refreshTimer = null;
  var gwpRefreshTimer = null;
  var selfInitiated = false;

  // ─── Section Rendering refresh ───

  function refreshSection() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return fetch('/cart?section_id=cart')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Swap line items
            swap(SELECTORS.lineItems, doc);
            // Swap subtotal
            swap(SELECTORS.cartSubtotal, doc);
            // Swap final price
            swapText(SELECTORS.cartFinal, doc);
            // Swap shipping message
            swapOuter(SELECTORS.cartMessage, doc);
            // Swap upsell
            swapOuter('[data-cart-page-upsell-wrapper]', doc);

            toggleCartStates(cart);
            updateHeaderBadge(cart);

            return cart;
          });
      });
  }

  function swap(sel, doc) {
    var fresh = doc.querySelector(sel);
    var current = document.querySelector(sel);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function swapText(sel, doc) {
    var fresh = doc.querySelector(sel);
    var current = document.querySelector(sel);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function swapOuter(sel, doc) {
    var fresh = doc.querySelector(sel);
    var current = document.querySelector(sel);
    if (fresh && current) {
      current.outerHTML = fresh.outerHTML;
    } else if (fresh && !current) {
      var container = document.querySelector('.cart__page__shipping');
      if (container) container.innerHTML = fresh.outerHTML;
    }
  }

  function toggleCartStates(cart) {
    var emptyEl = document.querySelector(SELECTORS.cartEmpty);
    var formEls = document.querySelectorAll(SELECTORS.cartForm);
    var bottomEl = document.querySelector(SELECTORS.cartBottom);

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.classList.remove('cart--hidden');
      formEls.forEach(function (el) { el.classList.add('cart--hidden'); });
      if (bottomEl) bottomEl.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.classList.add('cart--hidden');
      formEls.forEach(function (el) { el.classList.remove('cart--hidden'); });
      if (bottomEl) bottomEl.style.display = '';
    }
  }

  function updateHeaderBadge(cart) {
    document.querySelectorAll(SELECTORS.headerCartCount).forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-header-cart-count', cart.item_count);
    });
    document.querySelectorAll(SELECTORS.headerCartPrice).forEach(function (el) {
      el.setAttribute('data-header-cart-price', cart.total_price);
    });
    document.querySelectorAll(SELECTORS.headerCartFull).forEach(function (el) {
      el.setAttribute('data-header-cart-full', cart.item_count > 0 ? 'true' : 'false');
    });
  }

  // ─── Dispatch theme:cart:change then schedule GWP follow-up refresh ───

  function dispatchAndRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Tell GWP engine about the cart change
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true,
            })
          );

          // Always do a follow-up section refresh after GWP engine
          // has had time to add/remove items (2.5s covers the GWP
          // fetch-rules + add/remove cycle)
          clearTimeout(gwpRefreshTimer);
          gwpRefreshTimer = setTimeout(function () {
            selfInitiated = true;
            refreshSection().then(function (freshCart) {
              selfInitiated = false;
              if (freshCart) {
                // Re-dispatch so GWP messages re-render
                document.dispatchEvent(
                  new CustomEvent('theme:cart:change', {
                    detail: { cart: freshCart },
                    bubbles: true,
                  })
                );
              }
            });
          }, 2500);
        });
    }, 300);
  }

  // ─── Watch for Pipeline's section refresh via MutationObserver ───

  var lineItems = document.querySelector(SELECTORS.lineItems);
  if (lineItems) {
    new MutationObserver(function () {
      // Skip mutations caused by our own refreshSection() to avoid loops
      if (selfInitiated) return;
      dispatchAndRefresh();
    }).observe(lineItems, { childList: true, subtree: true });
  }

  // ─── Intercept fetch for /cart/change and /cart/update ───

  var nativeFetch = window.fetch;
  window.fetch = function (url, opts) {
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var isCartOp = urlStr.indexOf('/cart/change') !== -1 ||
                   urlStr.indexOf('/cart/update') !== -1;

    var result = nativeFetch.apply(this, arguments);

    if (isCartOp && !selfInitiated) {
      result.then(function () {
        // Give Pipeline time to finish its section refresh, then dispatch
        setTimeout(dispatchAndRefresh, 600);
      });
    }

    return result;
  };

  // ─── Initial GWP trigger on page load ───
  dispatchAndRefresh();
})();
